import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import { useSidebar } from "../../App";

export default function HelpAiEndpoint() {
  const { sidebarCollapsed } = useSidebar();
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* 🔹 Internal CSS */}
      <style>
        {`
          .accordion {
            background-color: #10172a;
            color: #ffffff;
            cursor: pointer;
            padding: 18px;
            width: 100%;
            border: none;
            text-align: left;
            font-size: 15px;
            border-radius: 6px;
            margin-top: 15px;
            position: relative;
          }

          .accordion::after {
            content: "+";
            position: absolute;
            right: 18px;
            top: 50%;
            transform: translateY(-50%);
            font-weight: bold;
            color: #9ca3af;
          }

          .accordion.active::after {
            content: "−";
          }

          .panel {
            background-color: #ffffff;
            overflow: hidden;
            transition: max-height 0.3s ease;
            border-radius: 0 0 6px 6px;
          }

          .help-row {
            display: flex;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          /* 50% TEXT */
          .help-row p {
            width: 50%;
            max-width: 50%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }

          /* 50% IMAGE */
          .help-row img {
            width: 50%;
            max-width: 50%;
            border-radius: 6px;
          }

          /* Mobile */
          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <Header />

      <div className="container-fluid">
        <div className="main-container">
          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{ width: "100%", overflowX: "auto" }}
          >
            <div className="dashboard">
              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t("helpAiEndpoint.title", "Create a New AI Endpoint")}
                </h1>
              </div>

              {/* Accordion */}
              <button
                className={`accordion ${open ? "active" : ""}`}
                onClick={() => setOpen(!open)}
              >
                {t("helpAiEndpoint.accordionTitle", "New AI Endpoint")}
              </button>

              <div
                ref={panelRef}
                className="panel"
                style={{
                  maxHeight: open
                    ? `${panelRef.current?.scrollHeight}px`
                    : "0px",
                }}
              >
                <div className="help-row">
                  <p>
                    {t(
                      "helpAiEndpoint.step1",
                      "1. Choose Configuration → AI Endpoints from sidebar, click New AI Endpoint, fill information and click Next"
                    )}
                  </p>
                  <img
                    src="/images/enpoint1.jpg"
                    alt="New AI Endpoint Step 1"
                  />
                </div>

                <div className="help-row">
                  <p>
                    {t(
                      "helpAiEndpoint.step2",
                      "2. Review details and complete the AI Endpoint creation"
                    )}
                  </p>
                  <img
                    src="/images/enpoint2.jpg"
                    alt="New AI Endpoint Step 2"
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}